<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
        <p-skeleton width="14rem" height="0.875rem" />
      </div>
      <div class="flex-1 min-h-0 overflow-auto p-4 space-y-2">
        @for (row of skeletonRows; track row) {
          <p-skeleton height="2.5rem" />
        }
      </div>
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <p class="text-red-800">{{ error() }}</p>
      <button type="button" (click)="loadProductTaxes()" class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg">Reintentar</button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
                  <i class="pi pi-percentage"></i>
                </span>
                Impuestos
              </h2>
              <p class="text-sm text-slate-500 mt-1">Catálogo de configuraciones de impuestos reutilizables.</p>
            </div>
            <a routerLink="/product-taxes/nuevo" class="inline-block" appDisableUnless="PRODUCT_TAX_WRITE">
              <p-button label="Nuevo impuesto" icon="pi pi-plus" severity="primary" size="small" appDisableUnless="PRODUCT_TAX_WRITE" />
            </a>
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 sm:flex sm:flex-wrap sm:items-end gap-2">
            <div class="min-w-0 col-span-2 sm:flex-1 sm:min-w-40">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <p-inputicon class="pi pi-search text-sm" />
                  <input pInputText id="filterProductTaxesQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.q.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.q.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterProductTaxesQ">Clave o nombre del impuesto</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 sm:w-32" variant="on">
              <p-select formControlName="state" inputId="filterProductTaxesState" [options]="stateFilterOptions" optionLabel="label" optionValue="value" size="small" [showClear]="true" class="w-full" />
              <label for="filterProductTaxesState">Estado</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end">
                <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" severity="secondary" type="button" (onClick)="clearFilters()" ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            [value]="productTaxes()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} impuestos"
            [loading]="loading()"
            [paginator]="true"
            sortMode="single"
            [sortField]="sortField()"
            [sortOrder]="sortOrder()"
            (onLazyLoad)="onLazyLoad($event)"
            styleClass="product-taxes-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2 min-w-[180px]">Impuesto</th>
                <th class="!px-2 !whitespace-nowrap !text-right" pSortableColumn="taxRate">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Tasa</span>
                    @if (sortField() === 'taxRate') {
                      <p-sortIcon field="taxRate" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right" pSortableColumn="taxAmount">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Monto</span>
                    @if (sortField() === 'taxAmount') {
                      <p-sortIcon field="taxAmount" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="applicationType">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Aplicación</span>
                    @if (sortField() === 'applicationType') {
                      <p-sortIcon field="applicationType" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="collectionType">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Cobro</span>
                    @if (sortField() === 'collectionType') {
                      <p-sortIcon field="collectionType" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="state">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Estado</span>
                    @if (sortField() === 'state') {
                      <p-sortIcon field="state" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors" (click)="openDetails(item)">
                <td class="!px-2 !py-2">
                  <div class="flex items-center gap-2 min-w-0">
                    <div class="shrink-0 h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600">
                      <i class="pi pi-percentage text-sm"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ item.tax?.displayName || item.tax?.taxKey || '—' }}</div>
                      <div class="text-xs text-slate-500 truncate">{{ item.tax?.taxKey || '' }}</div>
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 text-sm text-slate-700 !text-right tabular-nums">{{ item.taxRate != null ? (item.taxRate | number:'1.0-6') + '%' : '—' }}</td>
                <td class="!px-2 !py-2 text-sm text-slate-700 !text-right tabular-nums">{{ item.taxAmount != null ? (item.taxAmount | number:'1.2-4') : '—' }}</td>
                <td class="!px-2 !py-2 text-sm text-slate-600">{{ applicationTypeLabel(item.applicationType) }}</td>
                <td class="!px-2 !py-2 text-sm text-slate-600">{{ collectionTypeLabel(item.collectionType) }}</td>
                <td class="!px-2 !py-2">
                  <p-tag class="!text-xs" [value]="item.state === 'ACTIVE' ? 'Activo' : 'Inactivo'" [severity]="getStateSeverity(item.state) ?? undefined" />
                </td>
                <td class="!px-2 !py-2 !text-right" (click)="$event.stopPropagation()">
                  <span class="inline-flex items-center gap-0.5">
                    <p-button icon="pi pi-pen-to-square" [rounded]="true" [text]="true" severity="secondary" (onClick)="editItem(item, $event)" appDisableUnless="PRODUCT_TAX_WRITE" />
                    <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (onClick)="openDeleteModal(item, $event)" appDisableUnless="PRODUCT_TAX_DELETE" />
                  </span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="!px-2 !py-12 !text-center !text-slate-500">No se encontraron impuestos con los filtros aplicados.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }
</div>

  @if (deleteModalOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black/50" (click)="closeDeleteModal()"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 z-10">
        <h3 class="text-lg font-semibold text-slate-900 mb-4">Confirmar eliminación</h3>
        <p class="text-sm text-slate-600 mb-6">¿Deseas eliminar este impuesto del catálogo? Se desvinculará de los productos asociados.</p>
        <div class="flex justify-end gap-3">
          <button type="button" mat-stroked-button (click)="closeDeleteModal()">Cancelar</button>
          <button type="button" mat-raised-button color="warn" [disabled]="deleteLoading()" (click)="confirmDelete()">
            {{ deleteLoading() ? 'Eliminando...' : 'Eliminar' }}
          </button>
        </div>
      </div>
    </div>
  }

  <p-drawer
    [visible]="isDetailsOpen()"
    position="right"
    (visibleChange)="onDrawerVisibleChange($event)"
    styleClass="product-tax-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <h3 class="text-lg font-semibold text-slate-900">Detalles del impuesto</h3>
        @if (selectedProductTax() && !detailsLoading()) {
          <button type="button" class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg" (click)="editFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (detailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-indigo-500"></i>
        <p class="text-sm text-slate-600">Cargando impuesto...</p>
      </div>
    } @else if (selectedProductTax()) {
      <app-product-tax-read [productTax]="selectedProductTax()!" />
    }
  </p-drawer>
</div>
